import { Component } from '@angular/core';

@Component({
  selector: 'app-cards9-examples-56',
  templateUrl: './cards9-examples-56.component.html'
})
export class Cards9Examples56Component {}
